import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const HOMII_API_URL = publicRuntimeConfig.HOMII_API_URL;

const mediaUrls = {
    getCityDocumentUrl: (cityId, documentId) =>
        `${HOMII_API_URL}City/document?CityId=${cityId}&DocumentId=${documentId}`,
    getCityDocumentThumbnailUrl: (scale, quality, cityId, documentId) =>
        `${HOMII_API_URL}City/document?CityId=${cityId}&DocumentId=${documentId}&scale=${scale}&quality=${quality}`,

    getBuildingDocumentUrl: (buildingId, documentId) =>
        `${HOMII_API_URL}Building/document?BuildingId=${buildingId}&DocumentId=${documentId}`,
    getBuildingDocumentThumbnailUrl: (scale, quality, buildingId, documentId) =>
        `${HOMII_API_URL}Building/document?BuildingId=${buildingId}&DocumentId=${documentId}&scale=${scale}&quality=${quality}`,

    getRoomTypeDocumentUrl: (roomTypeId, documentId) =>
        `${HOMII_API_URL}RoomType/document?RoomTypeId=${roomTypeId}&DocumentId=${documentId}`,
    getRoomTypeDocumentThumbnailUrl: (scale, quality, roomTypeId, documentId) =>
        `${HOMII_API_URL}RoomType/document?RoomTypeId=${roomTypeId}&DocumentId=${documentId}&scale=${scale}&quality=${quality}`,

    getPortfolioDocumentUrl: (portfolioId, documentId) =>
        `${HOMII_API_URL}Portfolio/document?PortfolioId=${portfolioId}&DocumentId=${documentId}`,
    getPortfolioDocumentThumbnailUrl: (scale, quality, portfolioId, documentId) =>
        `${HOMII_API_URL}Portfolio/document?PortfolioId=${portfolioId}&DocumentId=${documentId}&scale=${scale}&quality=${quality}`,

    getAgentDocumentUrl: (agentId, documentId) =>
        `${HOMII_API_URL}Agent/document?AgentId=${agentId}&DocumentId=${documentId}`,
    getAgentDocumentThumbnailUrl: (scale, quality, agentId, documentId) =>
        `${HOMII_API_URL}Agent/document?AgentId=${agentId}&DocumentId=${documentId}&scale=${scale}&quality=${quality}`,
};

export default mediaUrls;